import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InitialDataModel } from 'src/app/services/models/initial-data-model.service';
@Component({
  selector: 'app-patient-disenrollment',
  templateUrl: './patient-disenrollment.component.html',
  styleUrls: ['./patient-disenrollment.component.scss'],
})
export class PatientDisenrollmentComponent implements OnInit, OnDestroy {
  disenrollmentOptions = [];
  disenrollmentForm: UntypedFormGroup;
  loading = false;
  unsubscribe = new Subject<void>();
  constructor(
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<PatientDisenrollmentComponent>,
    private dataService: InitialDataModel
  ) {}

  ngOnInit(): void {
    this.dataService
      .getDisenrollmentOptions()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((options) => {
        this.disenrollmentOptions = options;
      });
    this.initDisenrollmentForm();
  }

  initDisenrollmentForm(): void {
    this.disenrollmentForm = this.fb.group({
      reason: ['', Validators.required],
    });
  }

  save(): void {
    const disenrollmentData = this.disenrollmentForm.getRawValue();
    this.dialogRef.close(disenrollmentData);
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
